import { Component } from '@angular/core';
import { ExceptionsService } from 'src/app/core/services/exceptions.service';

@Component({
  standalone: false,
  selector: 'app-ag-grid-exception-renderer',
  templateUrl: './ag-grid-exception-renderer.component.html',
  styleUrl: './ag-grid-exception-renderer.component.scss'
})
export class AgGridExceptionRendererComponent {
  assignment: any;
  userId: string | undefined;
  multipleUserExceptionAccess: boolean = false;
  constructor(private exceptionsService: ExceptionsService) {}

  agInit(params: any): void {
    const label = params.label;
    const assignments = params.data.assignments || params.data[label] ;
    this.multipleUserExceptionAccess = params.multipleUserExceptionAccess ?? false;
    
    if(this.multipleUserExceptionAccess){
      this.assignment = params.data.smeAssignment
    }else{
      if( !assignments || !Array.isArray(assignments) || assignments.length === 0) {
        this.assignment = assignments != null ? assignments.userName: ''
        this.userId = assignments !=null? assignments.userId: '';
      }else{

        const assignment = assignments.find(
          (assignment: any) => assignment.label === label
        );
        this.assignment = params.getAssignmentNameByLabel(
          label,
          assignments
        );
        this.userId = assignment ? assignment.userId : undefined;
      }
    }

  }

  hasUserExceptionAccess(userId: string | undefined | null): boolean {
    return this.exceptionsService.hasUserExceptionAccess(userId);
  }
  
}
